import { render, staticRenderFns } from "./PriceTableTN.vue?vue&type=template&id=66b887c6&"
import script from "./PriceTableTN.vue?vue&type=script&lang=js&"
export * from "./PriceTableTN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports